// =============================================================
// 実験実施時の表示設定
//
// キャンバス下の開発・調整用ボタン（DL／グリッド／カメラ位置）は、
// 学習者が触る画面（演習・研究発表デモ）では出さない。
// 一致視点やカメラ位置を調整したいときだけ .env.local で有効にする:
//   REACT_APP_SHOW_MODEL_TOOLBAR=true
//
// 旧デモ画面（/viewer・/demo1・/demo4 など）は ModelViewer の既定（表示）のまま。
// =============================================================

export const SHOW_MODEL_TOOLBAR = process.env.REACT_APP_SHOW_MODEL_TOOLBAR === 'true';
